module.exports = __webpack_public_path__ + "static/media/slate_schieber.76abc952.png";